var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAmericanExpress = function SvgAmericanExpress(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 767,
    height: 168,
    fill: "currentColor",
    viewBox: "0 0 767 168",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m127.517 94.915-27.314-66.558-27.159 66.558zM389.5 166.957l-.151-130.76-57.867 130.76h-35.039L238.426 36.082v130.875h-81.168l-15.334-37.239h-83.09l-15.49 37.239H0L71.463 0h59.292l67.873 158.074V0h65.133l52.226 113.26L363.963 0h66.443v166.957zm104.419-34.163V99.568h87.613V65.496h-87.613V35.135H593.97L637.621 83.8l-45.584 48.993zm270.384 34.803h-51.855l-49.139-55.284-51.069 55.284H454.166V.599h160.507l49.099 54.74L714.533.598h52.134l-77.555 83.499z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmericanExpress);
export default ForwardRef;